import { dotnetApi } from "@gik/core/api/ky/dotnetApi";

export function acceptGroupInvitation(inviteRef: string, refreshToken: string) {
	return dotnetApi.post(`invitations/${inviteRef}`, {
		json: {
			refreshToken,
		},
	});
}
